// material-ui
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

// third-party

// project imports
import { useSelector, RootState } from "store";

// assets
import LOADING from "assets/images/loading/loading.png";

// styles

// ==============================|| LOADER ||============================== //

const LoadingModal = (): JSX.Element => {
  const global = useSelector((state: RootState) => state.global);

  return (
    <Modal open={global.isLoading} disableEnforceFocus disableAutoFocus>
      <Grid
        container
        direction="column"
        alignItems={"center"}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)"
        }}
      >
        <img src={LOADING} alt="" width={"72px"} height={"80px"} />
        <Typography variant="body1" fontSize={"1.3125rem"} textAlign="center" mt={"30px"} letterSpacing={"6px"}>
          LOADING...
        </Typography>
      </Grid>
    </Modal>
  );
};

export default LoadingModal;
